__turbopack_context__.v({
  "banner-buttons": "instructor-community-banner-module-scss-module__w4zX_W__banner-buttons",
  "banner-container": "instructor-community-banner-module-scss-module__w4zX_W__banner-container",
  "banner-container-mobile": "instructor-community-banner-module-scss-module__w4zX_W__banner-container-mobile",
  "banner-content": "instructor-community-banner-module-scss-module__w4zX_W__banner-content",
  "banner-content-mobile": "instructor-community-banner-module-scss-module__w4zX_W__banner-content-mobile",
  "banner-description": "instructor-community-banner-module-scss-module__w4zX_W__banner-description",
  "banner-photo-mobile": "instructor-community-banner-module-scss-module__w4zX_W__banner-photo-mobile",
  "banner-title": "instructor-community-banner-module-scss-module__w4zX_W__banner-title",
});
